import React, { useEffect, useState } from 'react'
import * as api from '../../api/account'
import { ErrorText, SectionTitle } from './ui'

/**
 * Wybór powiadomień na platformie (prośba właściciela 2026-10-11): które typy ma dostawać to konto.
 * Zapis od razu po zaznaczeniu. Lista typów, nazwy i opisy idą z serwera (`accounts/powiadomienia.py` TYPY),
 * więc nowy typ pojawia się tu bez zmian we froncie. Powiadomienia widać pod dzwonkiem w pasku.
 */
const PowiadomieniaSection = ({ setFlash }) => {
  const [typy, setTypy] = useState(null)
  const [error, setError] = useState('')
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    let anulowane = false
    api.getUstawieniaPowiadomien().then((res) => {
      if (anulowane) return
      if (res.ok) setTypy(res.data.typy)
      else setError(res.error)
    })
    return () => { anulowane = true }
  }, [])

  if (!typy) return error ? <ErrorText>{error}</ErrorText> : <p className="py-6 text-sm text-gray-500">Wczytuję ustawienia…</p>

  const przelacz = async (klucz, wlaczone) => {
    const wylaczone = typy.filter((t) => (t.klucz === klucz ? !wlaczone : !t.wlaczone)).map((t) => t.klucz)
    setBusy(true)
    setError('')
    const res = await api.zapiszUstawieniaPowiadomien(wylaczone)
    setBusy(false)
    if (!res.ok) { setError(res.error); return }
    setTypy(res.data.typy)
    // Dzwonek w pasku odświeża listę od razu (nasłuchuje tego zdarzenia).
    window.dispatchEvent(new Event('vv-powiadomienia-odswiez'))
    setFlash?.('Zapisano ustawienia powiadomień.')
  }

  return (
    <div>
      <SectionTitle hint="Powiadomienia pokazują się pod dzwonkiem w prawym górnym rogu. Wybierz, o czym chcesz być informowany. Dostajesz je tylko o klientach, których widzisz na swoim koncie.">
        Powiadomienia
      </SectionTitle>
      <ul className="divide-y divide-gray-100 rounded-xl border border-gray-200">
        {typy.map((t) => (
          <li key={t.klucz}>
            <label className="flex cursor-pointer items-center gap-4 px-4 py-3.5 hover:bg-gray-50">
              <span className="min-w-0 flex-1 text-sm leading-5">
                <span className="block font-medium text-gray-900">{t.nazwa}</span>
                <span className="text-xs text-gray-500">{t.opis}</span>
              </span>
              {/* Przełącznik zamiast pola wyboru: stan „włączone / wyłączone” czyta się z niego od razu. */}
              <input type="checkbox" role="switch" aria-checked={t.wlaczone} className="peer sr-only"
                     checked={t.wlaczone} disabled={busy} onChange={(e) => przelacz(t.klucz, e.target.checked)} />
              <span aria-hidden="true"
                    className="relative h-6 w-11 flex-shrink-0 rounded-full bg-gray-300 transition-colors
                               after:absolute after:left-0.5 after:top-0.5 after:h-5 after:w-5 after:rounded-full
                               after:bg-white after:shadow after:transition-transform after:content-['']
                               peer-checked:bg-blue-600 peer-checked:after:translate-x-5
                               peer-focus-visible:ring-2 peer-focus-visible:ring-blue-500 peer-focus-visible:ring-offset-2
                               peer-disabled:opacity-60" />
            </label>
          </li>
        ))}
      </ul>
      <ErrorText>{error}</ErrorText>
    </div>
  )
}

export default PowiadomieniaSection
